var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66667 14.1667H13.3333M9.18141 2.30335L3.52949 6.69929C3.15168 6.99314 2.96278 7.14006 2.82669 7.32406C2.70614 7.48705 2.61633 7.67067 2.56169 7.86589C2.5 8.08628 2.5 8.3256 2.5 8.80423V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H14.8333C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7668 17.5 14.8333V8.80423C17.5 8.3256 17.5 8.08628 17.4383 7.86589C17.3837 7.67067 17.2939 7.48705 17.1733 7.32406C17.0372 7.14006 16.8483 6.99314 16.4705 6.69929L10.8186 2.30335C10.5258 2.07564 10.3794 1.96178 10.2178 1.91802C10.0752 1.8794 9.92484 1.8794 9.78221 1.91802C9.62057 1.96178 9.47418 2.07564 9.18141 2.30335Z",
    stroke: "#6B7280",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLine);
export default __webpack_public_path__ + "static/media/home-line.53ef3d61eb4de08209c48c7645641863.svg";
export { ForwardRef as ReactComponent };